import { Component, OnInit, ViewChild } from '@angular/core';
import { ListTableComponent } from '../../../../shared/components/list-table/list-table.component';
import { BillingFilterComponent } from '../../billing-filter/billing-filter.component';
import { ListService } from '../../../../shared/services/list.service';
import { BillingService } from '../../../../services/billing.service';
import { DatePipe } from '@angular/common';
import { SharedDataService } from '../../../../shared/services/shared-data-service';
import { STATIC_DATA, STATIC_JSON_DATA_PATH } from '../../../../shared/constants/static-data.constants';
import { PAGE_CONSTANTS } from '../../../../shared/constants/page.constants';
import { ActivatedRoute } from '@angular/router';
import { UserService } from '../../../../services/user.service';
import { LoggerService } from '../../../../shared/services/logger.service';
import { SectionsService } from '../../../../services/sections.service';


@Component({
  selector: 'ppl-cdr-list',
  standalone: true,
  imports: [ListTableComponent, BillingFilterComponent],
  templateUrl: './cdr-list.component.html',
  styleUrl: './cdr-list.component.css',
})
export class CdrListComponent implements OnInit {
  sharedDataKey: string = STATIC_DATA.SHARED_CDR_RECON_DATA;
  pageId: string = PAGE_CONSTANTS.CDR_RECON_GRID_PAGE;
  programName!: string;
  appliedFilters: any;
  cdrRecons: any[] = [];

  @ViewChild(ListTableComponent) childComponent!: ListTableComponent;

  fields = [
    { field: 'timeframe', show: true, default: '30 days' },
    { field: 'pplIcn', show: true },
    { field: 'eventCode', show: true },
  ];

  cols = [];

  constructor(
    private listService: ListService,
    private billingService: BillingService,
    private datePipe: DatePipe,
    private sharedDataService: SharedDataService,
    private route: ActivatedRoute,
    private userService: UserService,
    private logger : LoggerService, 
    private sectionService : SectionsService
  ) {}

  ngOnInit(): void {
    const selectedProgram = this.userService.getSelectedProgram();
    this.programName = selectedProgram?.program_code ?? '';
    const navigationState = window.history.state;
    this.getColumnData();
    if (navigationState.fileId) {
      const { fileId } = navigationState;
      const filters = [];
      console.log(fileId);
      filters.push({
        jsonPath: 'tasBillingReconFileMasterId',
        value: fileId,
        operator: 'Equal',
      });
      this.searchCdr(filters);
    } else {
      console.log('No state data available');
    }
  }

  async getColumnData() {
    try {
        const tempCols = await this.sectionService.getJsonConfigurationData(
          STATIC_JSON_DATA_PATH.CDR_LIST_PAGE_HEADERS,
          'billing'
        );
        this.cols = tempCols.columns;
    } catch (e) {
      this.logger.debug('Error in getting column data', e);
    }
  }

  onSearch(filters: any) {
    this.appliedFilters = filters;
    this.searchCdr(filters);
  }

  buildRequestPayload(
    pageName: string,
    orderBy: string,
    searchParams: [],
    startingPageNumber = 1
  ) {
    const payload: any = {
      pageName: pageName,
      programCode: this.programName,
      condition: 'and',
      recordsPerPage: 20,
      startingPageNumber: startingPageNumber,
      searchParam: searchParams,
      orderByColumn: orderBy ? [orderBy] : [],
      orderBy: ['desc'],
    };
    return payload;
  }
  searchCdr(filters: any, startingPageNumber = 1, currentPage = 0) {
    if (startingPageNumber == 1) {
      this.cdrRecons = [];
    }
    const processedPayload = this.buildRequestPayload(
      'billingCdrFileDetailView',
      'createddate',
      filters,
      startingPageNumber
    );
      this.listService
        .getListData(processedPayload, 'billing')
        .subscribe((data: any) => {
          const records = data.responsedata;
          records.forEach((element: any) => {
            element.eventCode = element.eventCode + ' - ' + element.eventDescription;
            // element.serviceDate = this.datePipe.transform(element.serviceDate, 'MM/dd/yyyy');
            // element.createddate = this.datePipe.transform(element.createddate, 'MM/dd/yyyy');
          });
          if (startingPageNumber > 1) {
            this.cdrRecons = [...this.cdrRecons, ...records];
            this.childComponent.resetPagination(startingPageNumber, currentPage);
          } else {
            this.cdrRecons = records;
          }
        });
  }

  rowClicked(event: any) {
    console.log('row clicked', event);
  }

  onAction(event: any) {
    console.log('action clicked', event);
  }

  onPageLoad(event: any) {
    this.searchCdr(
      this.appliedFilters,
      event.startingPageNumber,
      event?.first ?? 0
    );
  }
  rowActions(event: any) {
    console.log('row actions', event);
  }

  clearData() {
    this.sharedDataService.clearData(this.sharedDataKey);
  }
}
